<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-md-12 margin_bottom_top">
        <div class="row">
          <div class="col-12 col-xl-8 mb-4 mb-xl-0">
            <h2 class="font-weight-bold">Open house</h2>
            <h5 class="font-weight-normal mb-0">
              ครั้งที่ 10 ประจำปี 2565 วันที่ 8-9 ธันวาคม
              <span class="text-primary"
                >แผนที่ภายในงาน และลงทะเบียน ตอบแบบสอบถาม</span
              >
            </h5>
          </div>
          <div class="col-12 col-xl-4">
            <div class="justify-content-end d-flex">
              <div class="dropdown flex-md-grow-1 flex-xl-grow-0"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card tale-bg">
          <div class="card-people mt-auto">
            <img @click="showSingle" src="images/map_bg02.png" alt="people" />
            <div class="weather-info">
              <div class="d-flex"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 grid-margin transparent">
        <h5 class="font-weight-normal center">
          <span class="text-primary center"
            >*สามารถลงทะเบียนเข้าร่วมงาน และตอบแบบสอบถาม ได้ทุกชั้นปี*</span
          >
        </h5>
        <div class="row">
          <div class="col-md-6 mb-4 stretch-card transparent">
            <div class="card card-tale">
              <div class="card-body center">
                <a target="_black" href="/" class=""
                  ><h3>ลงทะเบียน(คลิกที่นี่)</h3></a
                >
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-4 stretch-card transparent">
            <div class="card card-dark-blue">
              <div class="card-body center">
                <a target="_black" href="/" class=""
                  ><h3>ตอบแบบสอบถาม(คลิกที่นี่)</h3></a
                >
              </div>
            </div>
          </div>
        </div>
        <h5 class="font-weight-normal center">
          <span class="text-primary center"
            >*สามารถตรวจสอบคุณสมบัติและสมัครได้ทุกคณะฟรี ผ่าน Google Form
            คุณวุฒิ ม.6 ปวช. ปวส.*</span
          >
        </h5>
        <div class="row">
          <div class="col-md-6 mb-4 stretch-card transparent">
            <div class="card card-tale_green">
              <div class="card-body center">
                <a
                  target="_black"
                  href="https://www.oapr.rmuti.ac.th/main/openhouse2566round1/"
                  class=""
                  ><h3>สมัครเรียน(คลิกที่นี่)</h3></a
                >
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-4 stretch-card transparent"></div>
        </div>
      </div>
    </div>
    <!-- <h5 class="font-weight-normal mb-0">
      กำหนดการ และคำถามที่พบบ่อย
      <span class="text-primary"></span>
    </h5> -->
    <div class="row">
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card tale-bg">
          <div class="card-people mt-auto">
            <img
              @click="showMultiple"
              src="images/openhouse.jpg"
              alt="people"
            />
            <div class="weather-info">
              <div class="d-flex"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 grid-margin transparent">
        <div class="card tale-bg">
          <div class="card-people mt-auto">
            <img
              @click="showMultiple"
              src="images/MAP-RMUTI02.jpg"
              alt="people"
            />
            <div class="weather-info">
              <div class="d-flex"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <a href="" title="hit counters free"
        ><img
          src="https://counter5.optistats.ovh/private/freecounterstat.php?c=qr5wufyk7kphb4p48976k4pecc36djmn"
          border="0"
          title="hit counters free"
          alt="hit counters free"
      /></a>
    </div>
  </div>

  <div>
    <!-- <button @click="showSingle">Show single picture.</button>
      <button @click="showMultiple">Show a group of pictures.</button>
      <img  src="images/map_openhouse02.png" alt="people" /> -->

    <vue-easy-lightbox
      :visible="visibleRef"
      :imgs="imgsRef"
      :index="indexRef"
      @hide="onHide"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import { ref, defineComponent } from "vue";
export default defineComponent({
  name: "HomeView",
  components: {
    VueEasyLightbox,
  },
  setup() {
    const visibleRef = ref(false);
    const indexRef = ref(0); // default 0
    const imgsRef = ref([]);

    const onShow = () => {
      visibleRef.value = true;
    };
    const showSingle = () => {
      imgsRef.value = "images/map_bg02.png";

      onShow();
    };
    const showMultiple = () => {
      imgsRef.value = ["images/openhouse.jpg", "images/MAP-RMUTI02.jpg"];

      indexRef.value = 0;
      onShow();
    };
    const onHide = () => (visibleRef.value = false);

    return {
      visibleRef,
      indexRef,
      imgsRef,
      showSingle,
      showMultiple,
      onHide,
    };
  },
});
</script>
<style scoped>
.margin_bottom_top {
  margin-bottom: 15px;
}
.center {
  text-align: center;
}
.btn_pra1 {
  background: #7da0fa;
}
.btn_pra2 {
  background: #4747a1;
}
.card-tale:hover {
  transform: scale(1.1);
}
.card-dark-blue:hover {
  transform: scale(1.1);
}
.card-tale_green:hover {
  transform: scale(1.1);
}
.card-tale_green {
  background: #add495;
  color: #ffffff;
}
h3 {
  color: white;
  text-decoration: underline;
  line-height: 2rem;
  text-shadow: 2px 2px 8px #000000;
}
span {
  line-height: 1.2rem;
  /* text-shadow: 2px 2px 8px #000000; */
}
.card-people:hover {
  transform: scale(1.1);
}
</style>
